import { PartialLodash } from '../services';

export function partialLodashMock(): PartialLodash {
  return {
    debounce: (fn: (...args: any[]) => unknown, delay?: number): any => {
      let timeoutId: ReturnType<typeof setTimeout>;
      function mockDebounce(...args: any[]) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn(...args), delay) as any;
        return;
      }
      mockDebounce.cancel = () => clearTimeout(timeoutId);
      return mockDebounce;
    },
    throttle: (fn: (...args: any[]) => unknown, delay?: number): any => {
      let timeoutId: ReturnType<typeof setTimeout> | null = null;

      const throttledFunction = function mockThrottle(...args: any[]) {
        if (timeoutId !== null) {
          return;
        }

        timeoutId = setTimeout(() => {
          fn(...args);
          timeoutId = null;
        }, delay) as any;
      };

      throttledFunction.cancel = () => {
        if (timeoutId !== null) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }
      };

      return throttledFunction;
    },
  };
}
